import { bindRequestLogic } from './utils'
import Types from '../actionTypes/firmwareVersionPers'
import { firmwareVersionPersAPI } from '../api'

export const getListFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.getListFirmwareVersionPers,
  type: Types.GET_LIST_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.GET_LIST_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.GET_LIST_FIRMWARE_VERSION_PERS_FAILED,
  isQueryParam: true
})

export const getDetailFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.getDetailFirmwareVersionPers,
  type: Types.GET_DETAIL_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.GET_DETAIL_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.GET_DETAIL_FIRMWARE_VERSION_PERS_FAILED
})

export const deleteFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.deleteFirmwareVersionPers,
  type: Types.DELETE_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.DELETE_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.DELETE_FIRMWARE_VERSION_PERS_FAILED
})

export const addFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.addFirmwareVersionPers,
  type: Types.ADD_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.ADD_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.ADD_FIRMWARE_VERSION_PERS_FAILED
})

export const updateFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.updateFirmwareVersionPers,
  type: Types.UPDATE_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.UPDATE_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.UPDATE_FIRMWARE_VERSION_PERS_FAILED
})

export const regenerateUuidFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.regenerateUuidFirmwareVersionPers,
  type: Types.REGENERATE_UUID_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.REGENERATE_UUID_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.REGENERATE_UUID_FIRMWARE_VERSION_PERS_FAILED
})

export const regenerateSegmentsFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.regenerateSegmentsFirmwareVersionPers,
  type: Types.REGENERATE_SEGMENTS_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.REGENERATE_SEGMENTS_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.REGENERATE_SEGMENTS_FIRMWARE_VERSION_PERS_FAILED
})

export const getSystemFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.getSystemFirmwareVersionPers,
  type: Types.GET_SYSTEM_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.GET_SYSTEM_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.GET_SYSTEM_FIRMWARE_VERSION_PERS_FAILED,
  isQueryParam: true
})

export const downloadFirmwareVersionPers = bindRequestLogic({
  clientFunc: firmwareVersionPersAPI.downloadFirmwareVersionPers,
  type: Types.DOWNLOAD_FIRMWARE_VERSION_PERS_REQUEST,
  successType: Types.DOWNLOAD_FIRMWARE_VERSION_PERS_SUCCESS,
  failType: Types.DOWNLOAD_FIRMWARE_VERSION_PERS_FAILED
})

export default [
  getListFirmwareVersionPers,
  getDetailFirmwareVersionPers,
  deleteFirmwareVersionPers,
  addFirmwareVersionPers,
  updateFirmwareVersionPers,
  regenerateUuidFirmwareVersionPers,
  regenerateSegmentsFirmwareVersionPers,
  getSystemFirmwareVersionPers,
  downloadFirmwareVersionPers
]
